import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ModalRef} from "../../../shared-module/services/modal.service";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {ModalEventTypes} from "../../../shared-module/enums/modal.event";

@Component({
    selector: 'app-logout-modal',
    imports: [
        ButtonComponent,
    ],
    templateUrl: './logout-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './logout-modal.component.scss'
})
export class LogoutModalComponent {
  readonly modalRef: ModalRef<LogoutModalComponent> = inject<ModalRef<LogoutModalComponent>>(ModalRef);

  public submit(): void {
    this.modalRef.close(null, ModalEventTypes.Confirmed);
  }
}
